import React from "react";
import { Cookie } from "lucide-react";

export default function CookiePolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <div className="flex items-center gap-3 mb-2">
        <Cookie className="w-8 h-8 text-[#e86a24]" />
        <h1 className="text-3xl md:text-4xl font-black text-[#1d3d3a]">Cookie Policy</h1>
      </div>
      <p className="text-sm text-slate-500 mb-8">Ultimo aggiornamento: 25 maggio 2026</p>

      <div className="space-y-6 text-slate-700 text-sm leading-relaxed">
        <Section title="Cosa sono i cookie">
          <p>
            I cookie sono piccoli file di testo che i siti web salvano sul tuo dispositivo per ricordare informazioni tra le visite. SAN MARINO MARKET utilizza esclusivamente <strong>cookie tecnici essenziali</strong> per il funzionamento della piattaforma, senza alcun cookie di profilazione pubblicitaria.
          </p>
        </Section>

        <Section title="Cookie utilizzati">
          <div className="overflow-x-auto rounded-xl border border-slate-200">
            <table className="min-w-full text-sm">
              <thead className="bg-slate-100 text-left text-xs">
                <tr>
                  <th className="px-3 py-2 font-bold">Nome</th>
                  <th className="px-3 py-2 font-bold">Tipo</th>
                  <th className="px-3 py-2 font-bold">Scopo</th>
                  <th className="px-3 py-2 font-bold">Durata</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200">
                <tr>
                  <td className="px-3 py-2 font-mono">smm_token</td>
                  <td className="px-3 py-2">Tecnico</td>
                  <td className="px-3 py-2">Mantenere l'autenticazione (JWT salvato in localStorage)</td>
                  <td className="px-3 py-2">30 giorni</td>
                </tr>
                <tr>
                  <td className="px-3 py-2 font-mono">smm_cookie_consent</td>
                  <td className="px-3 py-2">Tecnico</td>
                  <td className="px-3 py-2">Ricordare la tua scelta sui cookie</td>
                  <td className="px-3 py-2">12 mesi</td>
                </tr>
                <tr>
                  <td className="px-3 py-2 font-mono">cache shell PWA</td>
                  <td className="px-3 py-2">Tecnico</td>
                  <td className="px-3 py-2">Funzionamento offline dell'app installata</td>
                  <td className="px-3 py-2">Fino a disinstallazione</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Section>

        <Section title="Cookie di terze parti">
          <p>
            Quando attivi le notifiche push, il browser comunica con i servizi push del produttore (Google FCM, Mozilla Push Service, Apple APNS) per consegnare le notifiche. Quando condividi una posizione in chat, vengono caricate mappe tile da OpenStreetMap. Quando paghi un servizio premium o l'iscrizione Azienda, vieni reindirizzato a Stripe. Le immagini degli annunci sono ospitate su Cloudinary (CDN). Queste integrazioni hanno proprie cookie policy.
          </p>
        </Section>

        <Section title="Come gestire i cookie">
          <p>
            Poiché utilizziamo solo cookie tecnici essenziali, non è necessario alcun consenso preventivo (Art. 122 Codice Privacy italiano e Direttiva ePrivacy). Tuttavia puoi sempre bloccarli/eliminarli dalle impostazioni del tuo browser. Disabilitare il cookie <code>smm_token</code> ti farà uscire dall'account.
          </p>
        </Section>

        <Section title="Contatti">
          <p>
            Per qualsiasi domanda sui cookie scrivi a <a href="mailto:privacy@sanmarinomarket.sm" className="text-[#e86a24] font-semibold">privacy@sanmarinomarket.sm</a>.
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-xl font-black text-[#1d3d3a] mb-2">{title}</h2>
      <div>{children}</div>
    </section>
  );
}
